module.exports = __webpack_public_path__ + "static/Baggage-second-iteration-4-1c1bdf442090dc1cb24020a515e4e016.png";